import React from "react";

import styles from "./OfferDetails.module.sass";
import Card from "../ui/Card/Card";
import api from "../../utils/api";
import currency from "../../utils/currency";
import OfferType from "../OfferType/OfferType";
import KeyValueItem from "../ui/KeyValueItem/KeyValueItem";
import ExpandArea from "../ui/ExpandArea/ExpandArea";
import { Col } from "react-bootstrap";
import Table from "../ui/Table/Table";
import Button from "../ui/Button/Button";
import TitleSection from "../TitleSection/TitleSection";
import ordering from "../../utils/ordering";
import OfferSimulation from "../OfferSimulation/OfferSimulation";
import DesktopOfferSimulation from "../OfferSimulation/DesktopOfferSimulation";
import gaTags from "./../../utils/ga-tags";
import theme from "../../App.module.sass";
import Alert from "../../components/Alert/Alert";
import AppContext from "../../contexts/appContext";
import Tooltip from "../ui/Tooltip/Tooltip";
import AccordionList from "../ui/AccordionList/AccordionList";
import { getFrequentlyAskedQuestions } from "../../utils/frequentlyAskedQuestions";
const ADM_LABEL = "Taxa de Administração";

const flexColumn = "flex-column"

const getEmphasis = condition => condition ? styles.tableEmphasis : styles.noEmphasis
const getDiscountText = discount => discount? `${ADM_LABEL} com oferta -` : `${ADM_LABEL} -`
const getParcelText = (begin, end) => begin === end ? `${begin}ª parcela` : `da ${begin}ª até a ${end}ª`
const getTooltipParcelas = (ibc) => (
  <Tooltip className={styles.info}>
    {ibc ? (
      <>
        <p>
          É constituído por Fundo Comum, Fundo de Reserva e Taxa de
          Administração. A Taxa de Administração é antecipada nas 24 primeiras
          parcelas.
        </p>
        <p>
          O valor do crédito e da parcela é corrigido a cada 12 assembleias do
          grupo, de acordo com o Índice Nacional de Preços ao Consumidor – INPC,
          garantindo assim, o seu poder de compra.
        </p>
      </>
    ) : (
      <>
        <p>
          É constituído por Fundo Comum, Fundo de Reserva, Taxa de Administração
          e Seguro Prestamista, se contratado. A Taxa de Administração é
          antecipada nas 24 primeiras parcelas.
        </p>
        <p>
          O valor do crédito e da parcela é corrigido a cada 12 assembleias do
          grupo, de acordo com o Índice Nacional de Preços ao Consumidor – INPC,
          garantindo assim, o seu poder de compra.
        </p>
      </>
    )}
  </Tooltip>
);

const getTooltipFundoComum = () => (
  <Tooltip className={styles.info} title="Fundo comum">
    <p>
      É o valor que será reunido para a compra do bem. É desse fundo que tiramos
      o crédito que será destinado aos contemplados.
    </p>
  </Tooltip>
);

const getTooltipTaxaAdm = () => (
  <Tooltip className={styles.info} title="Taxa de administração">
    <p>
      É o valor que a gente cobra para administrar seu consórcio. A Taxa de
      Administração é diferente dos juros cobrados em outras modalidades, por
      isso é bem menor. Ela é dividida durante o tempo contratado.
    </p>
  </Tooltip>
);

const getTooltipFundoReserva = () => (
  <Tooltip className={styles.info} title="Fundo de reserva">
    <p>
      Esse fundo é essencial para manter a saúde financeira do grupo. O valor é
      destinado a uma reserva para casos de imprevistos como cobrir uma eventual
      falta de dinheiro no Fundo Comum e, havendo saldo no encerramento do
      grupo, o mesmo será devolvido aos consorciados ativos.
    </p>
  </Tooltip>
);

const getDiscountTooltipText = discount => discount ? (
  <span className={styles.discount}>
    Taxa de Administração com oferta -{" "}
    {getTooltipTaxaAdm()}
  </span>
) : (
  <>
    {ADM_LABEL} - {getTooltipTaxaAdm()}
  </>
)

class OfferDetails extends React.Component {
  state = {
    vlrParcela: 0,
    vlrCredito: 0,
    situacao: "",
    taxaAdministracao: 0,
    lanceMedio: 0,
    parcelas: [],
    openedIndex: -1,
    showDesktopSimulation: false,
  };
  static contextType = AppContext;

  componentDidMount() {
    const group = this.props.offer.group;

    const requestBody = {
      codigoBem: group.codigoBem,
      codigoEmpresa: api.CODIGO_EMPRESA,
      codigoComissionado: api.CODIGO_COMISSIONADO(),
      grupo: {
        codigo: group.identificacao.codigo,
        codigoPlanoVenda: group.dados.plano.identificacao.codigo,
        codigoTaxaPlano: group.dados.plano.identificacao.codigoTaxa,
        codigoVenda: group.identificacao.codigoVenda,
        lanceMedio: group.dados.valorLanceMedio,
      },
    };

    api.post(api.endpoints.OFFERS_DETAILS, requestBody).then((result) => {
      this.setState({
        vlrParcela: result.data.dados.valorParcela,
        vlrCredito: result.data.dados.valorCredito,
        situacao: result.data.dados.situacao,
        porcentagemLanceFixo: result.data.dados.porcentagemLanceFixo,
        taxaAdministracao: result.data.dados.taxaAdministracao,
        taxaAdministracaoOld: result.data.dados.taxaAdministracaoAnterior,
        lanceMedio: result.data.dados.lance.valor,
        parcelas: ordering.quotas(result.data.dados.plano.detalhes.parcelas),
        desconto: result.data.dados.desconto === true,
        openedIndex: -1,
      });
      if (this.props.hasOwnProperty("adminTax")) {
        this.props.adminTax(result.data.dados.taxaAdministracao);
      }
    });
  }

  detailHandler = (index, state) => {
    this.setState({
      openedIndex: state ? index : -1,
    });
  };

  getOfferText = () => {
    if (this.state.desconto){
       return " com oferta";
    } else {
      return "";
    }
  };

  getOfferClassName = () => {
    if (this.state.desconto){
      return styles.discount;
    }else{
      return "";
    }
  };

  renderOfferComponent = (mobile) => {
    if (this.state.desconto) {
      return (
        <>
          <span className={styles.discountOld}>
            de{" "}
            <span className={styles.oldValue}>
              {this.state.taxaAdministracaoOld}%
            </span>
          </span>
          <span className={styles.discountNew}>
            por {this.state.taxaAdministracao}%
          </span>
        </>
      );
    } else {
      if (mobile) {
        return <>{`${this.state.taxaAdministracao}%`}</>;
      }
      return (
        <span className={styles.value}>{this.state.taxaAdministracao}%</span>
      );
    }
  };

  getDuration = () =>
      this.props.offer == null
        ? 0
        : this.props.offer.group.dados.plano.prazo.restante;

  render() {
    const gaTypeName = `${gaTags.typeFlow}&${this.state.lanceMedio}&-`;

    return (
      <div className={styles.OfferDetails}>
        {this.props.internalError && (
          <div className={theme.alertError}>
            <Alert error title="Ops!" text={this.props.internalError()} />
          </div>
        )}
        {this.props.isDesktop ? (
          <div className={flexColumn}>
            <span className={styles.situacao}>
              {enumSituacao[this.state.situacao]}
            </span>
            <div className={styles.divider} />
            <div className={styles.OfferTypeWrapper}>
              <OfferType large showIcon={true} type={this.props.productType} />
              <div className={flexColumn}>
                <span>Parcelas a partir de </span>
                <span className={styles.value}>
                  {"R$ " + currency.numberToCurrency(this.state.vlrParcela)}
                </span>
                <span>em {`${this.getDuration()} meses`}</span>
              </div>
              <div className={flexColumn}>
                <span>Valor do crédito</span>
                <span className={styles.value}>
                  {"R$ " + currency.numberToCurrency(this.state.vlrCredito)}
                </span>
              </div>
              <Col md={2} className={flexColumn}>
                <span className={this.getOfferClassName()}>
                  Taxa de Administração {this.getOfferText()}
                </span>
                {this.renderOfferComponent(false)}
              </Col>
              <Col md={2} className={flexColumn}>
                <span>Não cobramos taxa de adesão</span>
              </Col>
            </div>
            <p className={styles.dispInfo}>Produto sujeito a disponibilidade</p>

            <div className={styles.divider} />
            {this.state.parcelas.length > 0 ? (
              <React.Fragment>
                <TitleSection title="Veja os detalhes das parcelas" />
                <Table
                  className={styles.tableOffer}
                  headers={[
                    {
                      text: "Parcelas",
                      bold: true,
                    },
                    {
                      text: "Valor das Parcelas -",
                      bold: true,
                      info: getTooltipParcelas(this.context.ibc),
                    },
                    {
                      text: "Fundo comum -",
                      info: getTooltipFundoComum(),
                    },
                    {
                      text: getDiscountText(this.state.desconto),
                      emphasis: this.state.desconto,
                      info: getTooltipTaxaAdm(),
                    },
                    {
                      text: "Fundo Reserva -",
                      className: styles.totalColumn,
                      info: getTooltipFundoReserva(),
                    },
                  ]}
                  rows={this.state.parcelas.map((el) => ({
                    interval: getParcelText(el.inicio, el.fim),
                    total: "R$ " + currency.numberToCurrency(el.valor),
                    fundoComum: (
                      <div className={flexColumn}>
                        <span>{`R$ ${currency.numberToCurrency(
                          el.fundoComum.valor
                        )}`}</span>
                        <span className={styles.subtitle}>
                          {currency.numberToPercentage(
                            el.fundoComum.porcentagem
                          )}
                        </span>
                      </div>
                    ),
                    taxaAdministracao: (
                      <div
                        className={[
                          flexColumn,
                          getEmphasis(this.state.desconto)
                            ,
                        ].join(" ")}
                      >
                        <span>{`R$ ${currency.numberToCurrency(
                          el.taxaAdministracao.valor
                        )}`}</span>
                        <span className={styles.subtitle}>
                          {currency.numberToPercentage(
                            el.taxaAdministracao.percentual
                          )}
                        </span>
                      </div>
                    ),
                    fundoReserva: (
                      <div className={flexColumn}>
                        <span>{`R$ ${currency.numberToCurrency(
                          el.fundoReserva.valor
                        )}`}</span>
                        <span className={styles.subtitle}>
                          {currency.numberToPercentage(
                            el.fundoReserva.porcentagem
                          )}
                        </span>
                      </div>
                    ),
                  }))}
                />
                <p className={styles.bottomInfo}>
                  {!this.context.ibc && (
                    <>
                      A partir da 2ª parcela, o cálculo desta simulação
                      considera o seguro prestamista.
                      <br />
                    </>
                  )}
                  Os percentuais desta simulação são calculados sobre o valor do
                  crédito.
                </p>
              </React.Fragment>
            ) : (
              <h2>Informações sobre parcelas ainda não disponíveis</h2>
            )}

            {this.state.situacao === "A" &&
              this.state.porcentagemLanceFixo > 1 && (
                <div className={styles.simulation}>
                  <TitleSection title="Simule um lance" />

                  <div className={styles.simulationHeader}>
                    <div className={styles.simulationTitle}>
                      <article className={styles.textSimulation}>
                        <p>
                          Lance é uma forma de você aumentar a chance de ser
                          contemplado antecipando o pagamento das parcelas. Faça
                          uma simulação de lance e veja como ficará o seu
                          consórcio em caso de contemplação.
                        </p>
                        <p>
                          A Caixa Seguradora é a única empresa onde você pode{" "}
                          <b>
                            pagar o lance usando até 50% do valor do crédito.
                          </b>{" "}
                          Aproveite esta vantagem para conseguir o seu crédito o
                          quanto antes!
                        </p>
                      </article>
                    </div>

                    <div className={styles.buttonSimulation}>
                      <Button
                        selected={this.state.showDesktopSimulation}
                        onClick={() => {
                          this.setState({
                            showDesktopSimulation: !this.state
                              .showDesktopSimulation,
                          });
                        }}
                        data-gacategory={gaTags.categoryFlow}
                        data-gatype={`${gaTypeName}Lance`}
                        data-gafunc={`${gaTypeName}QueroSimularLance`}
                      >
                        Quero simular um lance
                      </Button>
                    </div>
                  </div>
                  <div className={styles.divider} />
                  {this.state.showDesktopSimulation && (
                    <DesktopOfferSimulation
                      parcelas={this.state.parcelas}
                      credito={this.state.vlrCredito}
                      oferta={this.props.offer && this.props.offer.group}
                      porcentagemLanceFixo={this.state.porcentagemLanceFixo}
                    />
                  )}
                </div>
              )}
          </div>
        ) : (
          <React.Fragment>
            <p className={styles.dispInfo}>Produto sujeito a disponibilidade</p>
            <Card showHeader={true}>
              <div className={styles.OfferTypeWrapper}>
                <OfferType showIcon={true} type={this.props.productType} />
                <span className={styles.situacao}>
                  {enumSituacao[this.state.situacao]}
                </span>
              </div>
              <div className={styles.divider} />
              <KeyValueItem
                Key={"Valor do crédito"}
                Value={"R$ " + currency.numberToCurrency(this.state.vlrCredito)}
              />
              <KeyValueItem
                Key={"Parcelas a partir de"}
                Value={"R$ " + currency.numberToCurrency(this.state.vlrParcela)}
              />
              <KeyValueItem Key={"Durante"} Value={`${this.getDuration()} meses`} />
              <KeyValueItem
                Key={
                  <span className={this.getOfferClassName()}>
                    {ADM_LABEL}
                    {this.getOfferText()}
                  </span>
                }
                Value={this.renderOfferComponent(true)}
              />
              <KeyValueItem noDivider Key={"Não cobramos taxa de adesão"} />
            </Card>

            {this.state.parcelas.length > 0 ? (
              <React.Fragment>
                <TitleSection title="Veja os detalhes das parcelas" />
                {this.state.parcelas.map((el, index) => (
                  <ExpandArea
                    key={index}
                    index={index}
                    open={index === this.state.openedIndex}
                    onClick={this.detailHandler}
                    title={getParcelText(el.inicio, el.fim)}
                  >
                    <div className={styles.parcelasInfo}>
                      <KeyValueItem
                        Key={<>Fundo comum - {getTooltipFundoComum()}</>}
                        Value={
                          <div className={flexColumn}>
                            <span>
                              {`R$ ${currency.numberToCurrency(
                                el.fundoComum.valor
                              )} - `}
                              <span className={styles.subtitle}>
                                {currency.numberToPercentage(
                                  el.fundoComum.porcentagem
                                )}
                              </span>
                            </span>
                          </div>
                        }
                        column
                      />
                      <KeyValueItem
                        Key={
                          getDiscountTooltipText(this.state.desconto)
                        }
                        Value={
                          <div className={flexColumn}>
                            <span>
                              {`R$ ${currency.numberToCurrency(
                                el.taxaAdministracao.valor
                              )} - `}
                              <span className={styles.subtitle}>
                                {currency.numberToPercentage(
                                  el.taxaAdministracao.percentual
                                )}
                              </span>
                            </span>
                          </div>
                        }
                        column
                      />
                      <KeyValueItem
                        Key={<>Fundo reserva - {getTooltipFundoReserva()}</>}
                        Value={
                          <div className={flexColumn}>
                            <span>
                              {`R$ ${currency.numberToCurrency(
                                el.fundoReserva.valor
                              )} - `}
                              <span className={styles.subtitle}>
                                {currency.numberToPercentage(
                                  el.fundoReserva.porcentagem
                                )}
                              </span>
                            </span>
                          </div>
                        }
                        column
                      />
                      <KeyValueItem
                        noDivider
                        Key={"Total"}
                        Value={"R$ " + currency.numberToCurrency(el.valor)}
                      />
                    </div>
                  </ExpandArea>
                ))}
                <p className={styles.bottomInfo}>
                  {!this.context.ibc && (
                    <>
                      A partir da 2ª parcela, o cálculo desta simulação
                      considera o seguro prestamista.
                      <br />
                    </>
                  )}
                  Os percentuais desta simulação são calculados sobre o valor do
                  crédito.
                </p>
              </React.Fragment>
            ) : (
              <h2>Informações sobre parcelas ainda não disponíveis</h2>
            )}

            {this.state.situacao === "A" &&
              this.state.porcentagemLanceFixo > 1 && (
                <div className={styles.simulation}>
                  <TitleSection title="Simule um lance" />
                  <OfferSimulation
                    parcelas={this.state.parcelas}
                    credito={this.state.vlrCredito}
                    oferta={this.props.offer && this.props.offer.group}
                    porcentagemLanceFixo={this.state.porcentagemLanceFixo}
                  />
                </div>
              )}
          </React.Fragment>
        )}

        <TitleSection title="Tire suas dúvidas sobre o Consórcio" />
        <AccordionList
          listItem={getFrequentlyAskedQuestions(this.context.ibc)}
        />
      </div>
    );
  }
}

export const enumSituacao = {
  A: "Grupo em andamento",
  F: "Grupo em formação",
};

export default OfferDetails;
